import { Link, ClassHelper } from 'components/lib';
import LogoImg from "@/images/ghs_logo_desktop.svg";
import Style from './logo.tailwind';

export function Logo(props){

  const Logo = {
    color: {
      logo: LogoImg,
      mark: LogoImg 
    },
    white: {
      logo: LogoImg,
      mark: LogoImg
    }
  }

  const logoStyle = ClassHelper(Style, props);
  
  return(
    <Link url='/' className={ logoStyle }>
      <img src={ Logo[props.color ? 'color' : 'white'][props.mark ? 'mark' : 'logo'] } alt='Logo' />
    </Link>
  )
}
